export const STATUS_KEY_AWAITING = 'AWAITING'
export const STATUS_KEY_PENDING = 'PENDING';
export const STATUS_KEY_INPROGRESS = 'INPROGRESS';
export const STATUS_KEY_COMPLETED = 'COMPLETED';
export const STATUS_KEY_PARTIAL = 'PARTIAL';
export const STATUS_KEY_CANCELED = 'CANCELED';
export const STATUS_KEY_PROCESSING = 'PROCESSING';
export const STATUS_KEY_FAIL = 'FAIL';
export const STATUS_KEY_ERROR = 'ERROR';

export const STATUSES_NAMES = {
  [STATUS_KEY_AWAITING]: 'Awaiting',
  [STATUS_KEY_PENDING]: 'Pending',
  [STATUS_KEY_INPROGRESS]: 'In progress',
  [STATUS_KEY_INPROGRESS]: 'In progress',
  [STATUS_KEY_COMPLETED]: 'Completed',
  [STATUS_KEY_PARTIAL]: 'Partial',
  [STATUS_KEY_CANCELED]: 'Canceled',
  [STATUS_KEY_PROCESSING]: 'Processing',
  [STATUS_KEY_FAIL]: 'Fail',
  [STATUS_KEY_ERROR]: 'Error',
}

export const STATUSES_ID = {
  [STATUS_KEY_PENDING]: 0,
  [STATUS_KEY_INPROGRESS]: 1,
  [STATUS_KEY_COMPLETED]: 2,
  [STATUS_KEY_PARTIAL]: 3,
  [STATUS_KEY_CANCELED]: 4,
  [STATUS_KEY_PROCESSING]: 5,
  [STATUS_KEY_FAIL]: 6,
  [STATUS_KEY_ERROR]: 7,
  [STATUS_KEY_AWAITING]: 8,
}

export const RESEND = 'resend';

export const EDIT_LINK = 'EDIT_LINK';
export const SET_PARTIAL = 'SET_PARTIAL';
export const UPDATE_REMAINS = 'UPDATE_REMAINS';
export const SET_REMAINS = 'SET_REMAINS';
export const CANCEL_REASON = 'CANCEL_REASON';
export const CANCEL_AND_REFUND = 'CANCEL_AND_REFUND';
export const ORDER_DETAILS = 'ORDER_DETAILS';
export const ORDER_INFO = 'ORDER_INFO';
export const ORDER_DETAILS_SUPER_ADMIN = 'ORDER_DETAILS_SUPER_ADMIN';
export const UPDATE_FROM_PROVIDER = 'UPDATE_FROM_PROVIDER';
export const MASS_CANCEL_AND_REFUND = 'MASS_CANCEL_AND_REFUND';
export const MASS_REQUEST_REFILL = 'MASS_REQUEST_REFILL';
export const MASS_REQUEST_CANCEL = 'MASS_REQUEST_CANCEL';
export const MASS_UPDATE_FROM_PROVIDER = 'MASS_UPDATE_FROM_PROVIDER';
export const SET_START_COUNT = 'SET_START_COUNT';
export const CHANGE_STATUS = 'CHANGE_STATUS';
export const MASS_CHANGE_STATUS = 'MASS_CHANGE_STATUS';
export const REQUEST_CANCEL = 'REQUEST_CANCEL';
export const RESEND_ORDER = 'RESEND_ORDER';
export const RESEND_ORDER_CONFIRM = 'RESEND_ORDER_CONFIRM';
export const REQUEST_REFILL = 'REQUEST_REFILL';
export const DISABLE_REFILL = 'DISABLE_REFILL';
export const MASS_RESEND = 'MASS_RESEND';
export const MASS_RESEND_CONFIRM = 'MASS_RESEND_CONFIRM';
export const COPY_ORDER_ID = 'COPY_ORDER_ID';
export const COPY_EXTERNAL_ID = 'COPY_EXTERNAL_ID';
export const COPY_ALL_COLUMN_DATA = 'COPY_ALL_COLUMN_DATA';
export const COPY_ALL_COLUMN_DATA_WITH_PROVIDER = 'COPY_ALL_COLUMN_DATA_WITH_PROVIDER';
export const COPY_LINK = 'COPY_LINK';
